import { Databus } from './databus'

const PLAYBACK_PING_DELAY = 5 * 1000

export type PlayerAnalyticsParameters = {
  mediaId: string
  pingUrl: string
}

export const isValidOptions = (
  parameters: PlayerAnalyticsParameters,
): parameters is PlayerAnalyticsParameters => {
  return !!parameters.pingUrl && !!parameters.mediaId
}

export class PlayerAnalytics {
  protected parameters: PlayerAnalyticsParameters

  constructor(parameters: PlayerAnalyticsParameters) {
    if (!isValidOptions(parameters)) {
      throw new Error(
        'Player Analytics Parameters must contains pingUrl and mediaId',
      )
    }

    this.parameters = parameters

    Databus.bootstrap({
      enabled: true,
      baseUrl: this.parameters.pingUrl,
      batchReportInterval: PLAYBACK_PING_DELAY,
    })
  }

  public dispose() {
    Databus.dispose()
  }

  public updateMediaId(mediaId: Parameters<typeof Databus.updateMediaId>[0]) {
    Databus.updateMediaId(mediaId)
  }

  public ovbserveMedia(media: HTMLVideoElement) {
    Databus.observe(media, this.parameters.mediaId)
  }

  public getParameters(): PlayerAnalyticsParameters {
    return this.parameters
  }
}
